import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

}



// WEBPACK FOOTER //
// /Users/charles/Documents/AState-Senior/HCI/proj/amd2/src/app/app.component.ts